export const REQUEST_BODY = { application: 'mailservice' };
export const MINUTES_TO_UPDATE = 10;
export const PATH = 'users/token';



// WEBPACK FOOTER //
// ./src/services/request/config/token.js